import React, { useState } from "react";
import { useDispatch } from "react-redux";

import {
  closeAlert,
  showDangerAlert,
  showSuccessAlert,
} from "../../../redux/actions/alert/alertActions";

import { MessageFormComponent } from "../../../components/public/singleSimTabs/activityTab/modal";

import { StyledContainer, StyledRating } from "./styledTeacherModal";

const TeacherFeedBackModal = ({ messageData, feedBackRun, loading }) => {
  const [ratingValue, setRatingValue] = useState(null);
  const dispatch = useDispatch();

  const handleChangeRating = (newValue) => {
    setRatingValue(newValue);
  };

  const handleFeedBackRun = (data) => {
    let activityData = {
      type: 4,
      recipient_user: messageData.created_by.id,
      sim_report_id: messageData.sim_report_id,
      reply_id: messageData.id,
      content: data?.textarea_message ? data?.textarea_message : "",
      title: ratingValue - 1,
    };
    feedBackRun(activityData)
      .then(() => {
        dispatch(closeAlert());
        dispatch(
          showSuccessAlert(
            ` نمره شما برای ${messageData.created_by.name} با موفقیت ارسال شد.`
          )
        );
      })
      .catch((error) => {
        dispatch(closeAlert());
        dispatch(
          showDangerAlert(
            error.response.data[0]
              ? error.response.data[0]
              : "ارسال نمره ناموفق بود،دوباره امتحان کنید"
          )
        );
      });
  };

  return (
    <StyledContainer className="mx-auto p-2 d-flex flex-column align-items-center">
      {!ratingValue && (
        <h3 className="mb-4 text-center">
          لطفا با انتخاب ستاره به گزارشکار نمره دهید!
        </h3>
      )}

      <StyledRating
        dir="ltr"
        name="lab-score"
        value={ratingValue}
        precision={1}
        onChange={(event, newValue) => {
          handleChangeRating(newValue);
        }}
      />
      {!ratingValue && (
        <div className="feedback-level d-flex flex-row justify-content-between">
          <span>عالی</span>
          <span>ضعیف</span>
        </div>
      )}
      {ratingValue && (
        <>
          <div className="w-100  mt-3 d-flex flex-column justify-content-start">
            <p className="student-name mb-1">{messageData.created_by.name}</p>
            <p className="student-message">{messageData.content}</p>
          </div>
          <MessageFormComponent
            title="پیام خود به دانش‌آموز را در این قسمت وارد کنید."
            buttonName="تایید"
            handleSendMessage={handleFeedBackRun}
            loading={loading}
          />
        </>
      )}
    </StyledContainer>
  );
};

export default TeacherFeedBackModal;
